function buildImageSrc(mime?: string | null, base64?: string | null): string | null {
    if (!mime || !base64) return null;
    return `data:${mime};base64,${base64}`;
}

export default buildImageSrc;
